import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
var NglBadge = (function () {
    function NglBadge() {
    }
    NglBadge.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-badge',
                    template: "\n    <span class=\"slds-badge\" [ngClass]=\"type ? 'slds-theme--' + type : ''\"><ng-content></ng-content></span>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglBadge.ctorParameters = function () { return []; };
    NglBadge.propDecorators = {
        'type': [{ type: Input },],
    };
    return NglBadge;
}());
export { NglBadge };
;
//# sourceMappingURL=badge.js.map